<div class="input-content">
    <ng-container *ngIf="isLoaded">
        <div *ngFor="let menuItem of menuItems;let i=index" class="section-thumbnail input-cell" [attr.id]="menuItem?.data?.contentId">
            <kve-menu-item-navigator [item]="menuItem" (toggleSelect)="toggleItem($event)"></kve-menu-item-navigator>
        </div>
    </ng-container>
</div>
